module.exports = __webpack_public_path__ + "static/img/16613 1.224aed5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/16613 1.png
// module id = s0NY
// module chunks = 1